var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRiskAssessm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2553 0.661133H1.74519C1.38736 0.661133 1.04419 0.778559 0.791167 0.987578C0.538143 1.1966 0.395996 1.48009 0.395996 1.77569V23.2245C0.395996 23.5201 0.538143 23.8036 0.791167 24.0126C1.04419 24.2216 1.38736 24.3391 1.74519 24.3391H23.2553C23.6131 24.3391 23.9563 24.2216 24.2093 24.0126C24.4623 23.8036 24.6045 23.5201 24.6045 23.2245V1.77569C24.6045 1.48009 24.4623 1.1966 24.2093 0.987578C23.9563 0.778559 23.6131 0.661133 23.2553 0.661133ZM22.677 22.7468H2.32342V2.25335H11.4466C11.5123 2.03483 11.6646 1.84075 11.8793 1.70204C12.094 1.56333 12.3587 1.48797 12.6313 1.48797C12.9039 1.48797 13.1686 1.56333 13.3833 1.70204C13.598 1.84075 13.7503 2.03483 13.816 2.25335H22.677V22.7468Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24477 19.5582H19.9934V21.1504H5.24477V19.5582ZM6.56955 10.2442L5.20654 11.3702L11.2934 16.3984L20.1274 9.10074L18.7644 7.97477L11.2934 14.1465L6.56955 10.2442ZM12.6313 3.50408C12.3076 3.50408 11.9971 3.39783 11.7681 3.20872C11.5392 3.01961 11.4106 2.76312 11.4106 2.49567C11.4108 2.41521 11.4224 2.33504 11.4453 2.25684H8.2628L9.4835 4.10196C9.53998 4.1872 9.62322 4.25831 9.72445 4.30781C9.82569 4.3573 9.9412 4.38336 10.0588 4.38325H15.0936C15.2072 4.38317 15.3188 4.35866 15.4174 4.31213C15.516 4.2656 15.5983 4.19865 15.6561 4.11788L16.9998 2.25684H13.8173C13.8407 2.33497 13.8526 2.41517 13.8527 2.49567C13.8527 2.62814 13.8211 2.75931 13.7597 2.88169C13.6983 3.00407 13.6083 3.11526 13.4949 3.20891C13.3815 3.30255 13.2468 3.37682 13.0986 3.42747C12.9505 3.47811 12.7917 3.50415 12.6313 3.50408Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRiskAssessm);
export default __webpack_public_path__ + "static/media/ic_risk_assessm.6bbbe77b91a865276203ec6b801a9947.svg";
export { ForwardRef as ReactComponent };